import { Typography } from '../../../summary/components/Typography.tsx';
import { Tkv2MarketConditionsSummaryContent } from '../../marketConditions/Tkv2MarketConditionsSummaryContent.tsx';
import { Tkv2MarketConditionsExportDeps } from '../../marketConditions/types.ts';
import { hasAdjustments } from '../AdjustmentBreakdown/hasAdjustments.ts';
import { SummarySection } from '../SummarySection.tsx';
import { TitleAndExportToggleLockup } from '../TitleAndExportToggleLockup.tsx';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { AdjustmentBreakdownMarketConditionsChart } from './AdjustmentBreakdownMarketConditionsChart.tsx';

export const AdjustmentBreakdownMarketConditions = (
  props: Tkv2PairedCostSummaryInterfaceV2 & {
    marketConditionsExportDeps?: Tkv2MarketConditionsExportDeps;
  },
) => {
  const commentaryProps = props.exportableCommentaries.market;

  if (
    [
      hasAdjustments(props.results, 'dateOfSale'),
      hasAdjustments(props.results, 'concessions'),
      hasAdjustments(props.results, 'termsOfSale'),
    ].every((val) => val === false)
  ) {
    return null;
  }

  return (
    <SummarySection>
      <TitleAndExportToggleLockup
        {...props}
        title="Market Adjustments"
        id="isMarketConditionsCommentaryInExportSwitch"
        commentary={commentaryProps}
        variant="h1"
      />
      <Typography variant="body1">
        Comparable sale prices were adjusted forward to reflect market value as of the effective
        date, based on local price trends. Where applicable, adjustments were also made for terms of
        sale, concessions, and list-to-sale price trends.
      </Typography>

      {/* TODO: move the other methods into this*/}
      {props.marketConditions.dateOfSaleAdjustment.selectedMethod === 'marketTrends' ? (
        <Tkv2MarketConditionsSummaryContent
          exportDeps={props.marketConditionsExportDeps}
          state={props.marketConditions}
        />
      ) : (
        <AdjustmentBreakdownMarketConditionsChart {...props} />
      )}
    </SummarySection>
  );
};
